import { observable } from "mobx";
import { AppConstants, Types } from "../../../common/APIConstants";
import GainLossTransactionAPI from "../services/gainloss-transaction-screen-service";
import GainLossListsScreenAPI from "../services/gainloss-lists-screen-service";
import GainLossSystemVarianceAPI from "../services/gainloss-system-variance-screen-service";
import { formatDecimalValue } from "../../../common/NumberFormatter";
import { ALL_DISTRICT_OR_DIVISION } from "../../../constants/common";
class GainLossSystemVarianceDataStore {
  @observable screenColumnDefinitions = {
    GainLossSystemVarianceScreen: [],
  };
  @observable rowData = [];
  @observable districts = [];
  @observable productionMonths = [];
  @observable jurisdiction;
  @observable district;
  @observable productionMonth;
  @observable auditData = [];
  @observable fieldNames = [];
  @observable showAuditPopUp = false;
  @observable headerNames = [
    "District",
    "System",
    "Show on Report",
    "Field Variance Explanation",
    "Show on Report",
    "Sr. Management Variance Explanation",
    "Show on Report",
    "Financial Variance Explanation",
    "Show on Report",
    "Last Saved By",
    "Last Saved Date",
  ];
  @observable fieldNames = [
    "District",
    "System",
    "ShowFieldVarianceReport",
    "FieldVarianceExplanationCommnet",
    "ShowFieldVarianceExplanationReport",
    "SeniorManagementComment",
    "ShowSeniorManagementReport",
    "FinancialComment",
    "ShowFinancialReport",
    "LastSavedBy",
    "LastSavedDateTime",
  ];

  setJurisdiction = (jurisdiction) => (this.jurisdiction = jurisdiction);
  setDistrict = (district) => (this.district = district);
  setProductionMonth = (productionMonth) =>
    (this.productionMonth = productionMonth);
  setRowData = (rowData) => (this.rowData = rowData);
  setAuditPopUp = (value) => (this.showAuditPopUp = value);
  setColumnDef = async (currentScreenChildren, CommonStore) => {
    CommonStore.toggleLoader();
    try {
      currentScreenChildren.forEach((child) => {
        const { screen, screenColumns: columns } = child;

        this.screenColumnDefinitions[child.screen.name] = [];
        this.screenColumnDefinitions[child.screen.name] =
          this.getAllColumnDefinitions(screen, columns);
      });
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (
        error.response &&
        error.response.data.includes("Data not available for selected date")
      ) {
        window.toastr.error(error.response.data);
      } else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };

  getAllColumnDefinitions = (screen, columns) => {
    const gridColumns = [];
    columns.forEach((column) => {
      gridColumns.push({
        field: column.name,
        tooltipField:
          column.name === "FieldVarianceComment"
            ? "FieldVarianceComment"
            : undefined,
        headerName: column.title,
        type: "text",
        singleClickEdit: column.title !== "Show on Report",
        hide: column.hidden,
        width: column.width ? column.width : 200,
        pinned: this.isPinned(column),
        keyCreator: (params) => {
          return this.getValueFomatter(params, column, screen)
            ? this.getValueFomatter(params, column, screen)
            : params.value;
        },
        editable: (params) => {
          return this.getIsEditable(params, column, screen);
        },
        cellClassRules: {
          "highlight-cell": (params) => {
            return this.getIsEditable(params, column, screen);
          },
          "grid-cell-custom": (params) => {
            return params.data ? true : false;
          },
        },
        cellRenderer: this.getCellRenderer(column),
        cellRendererParams: (params) =>
          this.getCellRendererParams(column, params),
        cellEditor: this.getCellEditor(column),
        cellEditorParams: (params) => this.getCellEditorParams(column, params),
        valueFormatter: (params) => {
          return this.getValueFomatter(params, column, screen);
        },
        cellStyle: (params) => {
          if (column?.readOnly && !params?.node?.data?.isNewRow) {
            return { backgroundColor: "LightGray" };
          }
        },
        comparator:
          column?.type === Types.DECIMAL
            ? (valueA, valueB) => valueA - valueB
            : undefined,
      });
    });
    return gridColumns;
  };

  getValue(params, screen, column) {
    return params.data[column.name];
  }

  getIsEditable(params, column, screen) {
    if (this.getIsDataReadOnly() || !params.data) return false;
    else {
      return !column.readOnly;
    }
  }

  getIsDataReadOnly() {
    /* Uncomment any of this to disable the editing on screen for past dates OR a week before */

    // return moment(this.headerDetails.endDateTime).isBefore(moment(), "day");
    // return moment(this.headerDetails.endDateTime).isBefore(moment().subtract(7, "days"), "day");
    return false;
  }

  getCellRenderer(column) {
    switch (column.type) {
      case Types.BOOLEAN:
        return "booleanCellEditor";
      case Types.DATE:
        if (column.name === "ProductionMonth") return "monthYearFormatter";
        return "dateFormatter";
      case Types.DATETIME:
        return "dateTimeFormatter";
      case Types.TEXT:
        if (column.name === "WithinTolerance") {
          return "ColorFormatter";
        } else return column.value;
      case Types.DECIMAL:
        switch (column?.name) {
          case "AfterShrinkageGainLossPercent":
          case "UnidentifiedGainLossPercent":
          case "Tolerance":
          case "Offset":
          case "GainLossPercent":
            return "decimalFormatter4Digits";
          //return `${formatDecimalValue(params?.value, 4, true, true)}%`; //Four decimal places, can be negative - with percent sign
          case "Throughput":
          case "GainLoss":
          case "AfterShrinkageGainLoss":
          case "UnidentifiedGainLoss":
            return "decimalFormatter";
          //return formatDecimalValue(params?.value, 2, true, true); //Two decimal places, can be negative
          default:
            return "decimalFormatter";
          //return formatDecimalValue(params?.value); //Two decimal places, can be negative
        }
    }
  }

  getCellEditor(column) {
    switch (column.type) {
      case Types.DROPDOWN:
        return "SmartSelectClearable";
      case Types.NUMBER:
        return "numericCellEditor";
      case Types.DECIMAL:
        return "decimalCellEditor";
      case Types.TEXT:
        if (
          column.name === "FieldVarianceExplanationCommnet" ||
          column.name === "SeniorManagementComment" ||
          column.name === "FinancialComment"
        ){
          return "agLargeTextCellEditor";
        }
      case Types.BOOLEAN:
        return "booleanCellEditor";
    }
  }
  getCellEditorParams(column, params) {
    switch (column.type) {
      case Types.DROPDOWN:
        return {
          values: column.refLookupData?.lookupValues.values,
          isPopup: true,
        };
      case Types.TEXT:
        if (
          column.name === "FieldVarianceExplanationCommnet" ||
          column.name === "SeniorManagementComment" ||
          column.name === "FinancialComment"
        )
          return { maxLength: 1500, cols: 100, rows: 20 };
    }
  }

  getCellRendererParams(column, params) {
    switch (column.type) {
      case Types.BOOLEAN:
        return { isDisabled: this.getIsDataReadOnly() };
    }
  }

  getValueFomatter(params, column, screen) {
    if (column.type === Types.DROPDOWN && column.refLookupData != null) {
      return this.lookupValue(column.refLookupData.lookupValues, params.value);
    }
  }

  isPinned(column) {
    return column?.name === "Division" || column?.name === "System"
      ? "left"
      : null;
  }

  lookupValue(mappings, key) {
    if (
      !mappings ||
      mappings === "undefined" ||
      !mappings.values.find((item) => item.value == key)
    )
      return null;
    else {
      let label = mappings.values.find((item) => item.value == key).label;
      return label;
    }
  }

  getDistricts = async (CommonStore, jurisdiction) => {
    if (!jurisdiction) return;
    CommonStore.toggleLoader();
    try {
      this.districts = [];
      const response = await GainLossListsScreenAPI.getEntityList({
        jurisdiction: jurisdiction,
        entityType: "Division/District",
      });
      response.data
        .filter((item) => item.isActive)
        .map((item) => {
          this.districts.push({
            value: item.entityName,
            label: item.entityName,
          });
        });
      // option "All" for district/division
      if(this.districts.length){
        this.districts.unshift(ALL_DISTRICT_OR_DIVISION)
      }
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
    }
  };

  getProductionMonths = async (CommonStore) => {
    CommonStore.toggleLoader();
    try {
      this.productionMonths = [];
      const { data } = await GainLossTransactionAPI.getProductionMonths();
      Object.values(data).forEach((value) => {
        this.productionMonths.push({
          value: value.value,
          label: value.label,
        });
      });
      if (data.some((item) => item.isActive))
        this.productionMonth = data.filter((item) => item.isActive)[0];
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
    }
  };

  getSystemVarianceData = async (CommonStore) => {
    if (!this.jurisdiction || !this.district || !this.productionMonth) return;
    this.rowData = [];
    CommonStore.toggleLoader();
    try {
      const requestData = {
        jurisdiction: this.jurisdiction?.value,
        division: this.district?.value,
        productionMonth: this.productionMonth?.value,
      };
      const { data } =
        this.jurisdiction?.value === "Plains - North"
          ? await GainLossSystemVarianceAPI.getPMCSystemVarianceData(
              requestData
            )
          : await GainLossSystemVarianceAPI.getPAASystemVarianceData(
              requestData
            );
      this.rowData = data?.map((item) => ({
        ...item,
        ShowFieldVarianceExplanationReport:
          item.ShowFieldVarianceExplanationReport ? "Yes" : "No",
        ShowFieldVarianceReport: item.ShowFieldVarianceReport ? "Yes" : "No",
        ShowFinancialReport: item.ShowFinancialReport ? "Yes" : "No",
        ShowSeniorManagementReport: item.ShowSeniorManagementReport
          ? "Yes"
          : "No",
      }));
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
    }
  };

  saveSystemVarianceData = async (CommonStore, systemVarianceData) => {
    CommonStore.toggleLoader();
    try {
      const { data } = await GainLossSystemVarianceAPI.saveSystemVarianceData(
        systemVarianceData
      );
      CommonStore.toggleLoader();
      window.toastr.success(
        AppConstants.GAIN_LOSS.SYSTEM_VARIANCE_SCREEN.TOAST_MESSAGES
          .SAVE_SUCCESS
      );
    } catch (error) {
      CommonStore.toggleLoader();
      if (
        error?.response?.data?.includes("Violation of UNIQUE KEY constraint")
      ) {
        window.toastr.error(
          AppConstants.GAIN_LOSS.SYSTEM_VARIANCE_SCREEN.TOAST_MESSAGES
            .SAVE_DUPLICATE_ERROR
        );
      } else {
        window.toastr.error(
          AppConstants.GAIN_LOSS.SYSTEM_VARIANCE_SCREEN.TOAST_MESSAGES
            .SAVE_GENERIC_ERROR
        );
      }
    }
  };

  getAuditData = async (CommonStore, requestData) => {
    if (!requestData?.SystemVarianceId) return;
    CommonStore.toggleLoader();
    this.auditData = [];
    try {
      let requestObj = {
        SystemVarianceId: requestData.SystemVarianceId,
      };

      const { data } =
        await GainLossSystemVarianceAPI.getSystemVarianceAuditData(requestObj);

      this.auditData = data;
      CommonStore.toggleLoader();
      return data;
    } catch (error) {
      CommonStore.toggleLoader();
      if (
        error.response &&
        error.response.data.includes(
          "Audit Data not available for selected row"
        )
      ) {
        window.toastr.error(error.response.data);
      } else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };
}

export default new GainLossSystemVarianceDataStore();
